import { Middleware } from '@reduxjs/toolkit';
import api from 'api/instance';

export const setAuthHeader = (accessToken?: string) => {
  console.log('Bearer ', accessToken);
  if (accessToken) {
    api.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  }
};

export const authorizationHeaderSetterMiddleware: Middleware = (_) => (
  next,
) => (action) => {
  return next(action);
};
